import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteData } from '../data/mockData';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';

const FoundersSection = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setIsVisible(true); }, { threshold: 0.2 });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-24 md:py-32 overflow-hidden" style={{ background: '#0a0a0a' }}>
      <div className="absolute inset-0 opacity-20" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,backgroundSize:'200px'}} />
      <div className="relative z-10 px-8 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <div className="relative order-2 lg:order-1" style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateX(0)' : 'translateX(-60px)', transition: 'all 1s cubic-bezier(0.16, 1, 0.3, 1)' }}>
            <div className="relative overflow-hidden rounded-sm"><img src={siteData.founders.image} alt="Founders" className="w-full h-auto object-cover" /></div>
          </div>
          <div className="order-1 lg:order-2" style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateX(0)' : 'translateX(60px)', transition: 'all 1s cubic-bezier(0.16, 1, 0.3, 1) 200ms' }}>
            <p className="text-sm md:text-base font-medium italic mb-3" style={{ color: '#A855F7' }}>{get(t.founders.subtitle)}</p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-8">{siteData.founders.heading}</h2>
            <div className="space-y-4 mb-8">
              {get(t.foundersDesc.description).map((p, i) => (
                <p key={i} className="text-gray-300 text-base md:text-lg leading-relaxed">{p}</p>
              ))}
            </div>
            <button onClick={() => { navigate('/team'); window.scrollTo({top:0}); }} className="inline-flex items-center gap-3 font-bold tracking-wider uppercase text-sm hover:gap-5 transition-all duration-300" style={{ color: '#A855F7' }}>
              {get(t.founders.cta)} <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
